<template>
  <canvas ref='canvas'></canvas>
</template>

<script>
import Chart from 'chart.js';
import ajax from '../ajax';

export default {
  name: 'BaseLiveGraph',

  props: {
    yAxisTitle: {
      type: String,
      default: 'Value',
    },
    title: {
      type: String,
      default: '',
    },
    secondsToKeep: {
      type: Number,
      default: 61,
    },
    initialMin: {
      type: Number,
      default: 0,
    },
    initialMax: {
      type: Number,
      default: 0,
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      chartConfig: {
        type: 'line',
        data: {
          labels: ['6', '5', '4', '3', '2', '1', '0'],
          datasets: [{
            label: 'My First dataset',
            backgroundColor: 'red',
            borderColor: 'red',
            data: [
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
            ],
            fill: false,
          }, {
            label: 'My Second dataset',
            fill: false,
            backgroundColor: 'blue',
            borderColor: 'blue',
            data: [
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
              this.getRandom(-100, 100),
            ],
          }],
        },
        options: {
          responsive: true,
          title: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Seconds ago',
              },
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Value',
              },
              ticks: {
                max: 100,
                min: -100,
              },
            }],
          },
          legend: {
            display: true,
          },
        },
      },
      chart: null, // Will be created when component is mounted

      configItems: [],
      requestsPerTick: [],
    };
  },
  mounted() {
    this.chart = new Chart(this.$refs.canvas.getContext('2d'), this.chartConfig);
  },

  methods: {

    config(configItems) {
      const this2 = this;

      this2.configItems = configItems;

      // Get all urls we need to request each tick
      const requestsPerTick = [];
      this2.configItems.forEach((item) => {
        if (item.externalData !== true && !requestsPerTick.includes(item.dataUrl)) {
          requestsPerTick.push(item.dataUrl);
        }
      });
      this2.requestsPerTick = requestsPerTick;

      // Setup the chart visual config
      this2.chartConfig.data.labels = [];
      for (let i = 0; i < this2.secondsToKeep + 1; i += 1) {
        this2.chartConfig.data.labels.push(`${(this2.secondsToKeep + 1) - (i + 1)}`);
      }

      // Setup the datasets
      this2.chartConfig.data.datasets = [];
      this2.configItems.forEach((item) => {
        this2.chartConfig.data.datasets.push({
          label: item.name,
          backgroundColor: item.color,
          borderColor: item.color,
          data: [],
          fill: false,
        });
        for (let i = 0; i < this2.secondsToKeep + 1; i += 1) {
          this2.chartConfig.data.datasets[this2.chartConfig.data.datasets.length - 1]
            .data.push(null);
        }
      });

      if (this2.title === '' || this2.title === null || this2.title === undefined) {
        this2.chartConfig.options.title.display = false;
      } else {
        this2.chartConfig.options.title.display = true;
        this2.chartConfig.options.title.text = this2.title;
      }

      // Set up the axes
      this2.chartConfig.options.scales.xAxes[0].ticks.min = `${this2.secondsToKeep - 1}`;
      this2.chartConfig.options.scales.xAxes[0].ticks.max = '0';
      this2.chartConfig.options.scales.yAxes[0].ticks.min = this.initialMin;
      this2.chartConfig.options.scales.yAxes[0].ticks.max = this.initialMax;
      this2.chartConfig.options.scales.yAxes[0].scaleLabel.labelString = this2.yAxisTitle;

      this2.chartConfig.options.legend.display = this.showLegend;

      this2.chart.update();
    },

    getRandom(min, max) {
      return Math.random() * (max - min) + min;
    },

    updateData() {
      // Retrieve all data required, put it in 'data' and give it to processData(...)
      const data = [];
      const this2 = this;
      this.requestsPerTick.forEach((requestPerTick) => {
        ajax.get(requestPerTick)
          .then((response) => {
            data[requestPerTick] = response.data;
            if (Object.keys(data).length === this2.requestsPerTick.length) {
              this2.processData(data, true);
            }
          })
          .catch((e) => {
            console.log(e); // eslint-disable-line no-console
            data[requestPerTick] = null;
            if (Object.keys(data).length === this2.requestsPerTick.length) {
              this2.processData(data, true);
            }
          });
      });
    },

    processData(data, internal) {
      const this2 = this;
      this.configItems.forEach((configItem, index) => {
        if (configItem.externalData === true && internal === true) {
          return;
        }
        if (configItem.externalData !== true && internal !== true) {
          return;
        }
        let itemToAdd;
        itemToAdd = data[configItem.dataUrl];
        configItem.item.forEach((subItem) => {
          itemToAdd = itemToAdd[subItem];
        });
        let itemToAddValue = itemToAdd[configItem.value];
        if (configItem.resolution !== null) {
          // console.log('TODO: Do something with resolution');
        }
        itemToAddValue *= configItem.factor;
        this2.chart.data.datasets[index].data.push(itemToAddValue);

        this2.chartConfig.options.scales.yAxes[0].ticks.min = Math.min(
          this2.chartConfig.options.scales.yAxes[0].ticks.min,
          itemToAddValue,
        );
        this2.chartConfig.options.scales.yAxes[0].ticks.max = Math.max(
          this2.chartConfig.options.scales.yAxes[0].ticks.max,
          itemToAddValue,
        );

        if (this2.chart.data.datasets[index].data.length > this2.secondsToKeep + 1) {
          this2.chart.data.datasets[index].data.shift();
        }
      });
      this.chart.update();
    },
  },

  timers: {
    updateData: { time: 1000, repeat: true, autostart: true },
  },
};
</script>
